import { styled, TextField } from "@mui/material";

export const CustomTextFieldStyle = styled(TextField)(
  ({ theme, borderColor, language_direction, height }) => ({
    border: borderColor && `1px solid ${borderColor}`,
    borderRadius: borderColor && "10px",

    "& .MuiOutlinedInput-root": {
      height: height ? height : "100%",
      flexDirection:
        language_direction && language_direction === "rtl"
          ? "row-reverse"
          : "row",
      "& input[type=number]": {
        MozAppearance: "text-field",
      },
      "& input[type=number]::-webkit-outer-spin-button": {
        WebkitAppearance: "none",
        margin: 0,
      },
      "& input[type=number]::-webkit-inner-spin-button": {
        WebkitAppearance: "none",
        margin: 0,
      },
    },
    "& .MuiFormHelperText-root": {
      marginLeft: "0px",
      marginTop: "5px",
    },
    "& .MuiOutlinedInput-input": {
      fontSize: "14px",
      fontWeight: 400,
      height: ".8em !important",
    },
  })
);
